import SongsAndStoriesContainer from 'components/SongsAndStories/SongsAndStoriesContainer'
import SongsAndStoriesPresentation from 'components/SongsAndStories/SongsAndStoriesPresentation'

export default {
  Container: SongsAndStoriesContainer,
  Presentation: SongsAndStoriesPresentation,
}
